/* eslint-disable jsx-a11y/img-redundant-alt */
import { Row, Table, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  pupSelector,
  storeProductSelector,
  surveySelector,
} from "../../../services/selector/index.";
import {
  IconEdit,
  IconEye,
  IconLock,
  IconNext,
  IconPolygon,
  IconPre,
  IconXmark,
} from "../../../assets/icon";
import "../../../assets/style/table/survey.scss";
import { useEffect, useState } from "react";
import { useMemo } from "react";
import { setOpenPUDelete } from "../../../services/slice/PopUpSlice";
import TranslateText from "../TranslateText";
import { formatPrice } from "../../../utils/functionCommon";
import {
  getLogProduct,
  setPageProduct,
} from "../../../services/slice/StoreSlice";
import { useTranslation } from "react-i18next";
import {
  deleteSurvey,
  getDataSurvey,
  getLogSurvey,
  setOpenEditSurvey,
  setStatusSurvey,
  setTypeSurvey,
} from "../../../services/slice/SurveySlice";
import ModalDelete from "../Modal/delete/ModalDelete";

const TableSurvey = () => {
  const dispatch = useDispatch();
  const surveyState = useSelector(surveySelector);
  const statePup = useSelector(pupSelector);
  const { dataDelete } = statePup;
  const { config, data, total, callBackRequest } = surveyState;
  const [page, setPage] = useState(0);
  const [isDeleteTbl, setIsDeleteTbl] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    dispatch(getDataSurvey(config));
  }, [config.search, config.status, config.typeSurvey, dispatch]);

  const dataSource = useMemo(() => {
    const result = data.map((item, index) => {
      return {
        ...item,
        object: item.typeSurvey === 1 ? "Toàn bộ KH" : "CCS",
        status:
          item.status === 1
            ? "Chưa diễn ra"
            : item.status === 2
            ? "Đang diễn ra"
            : "Đã kết thúc",
        STT: total > 10 && page >= 2 ? (page - 1) * 10 + index + 1 : index + 1,
        key: item.id,
      };
    });
    return result;
  }, [data, total, page]);
  const rowClassName = (record) => {
    return record.typeSurvey === 2 ? "marked-row" : "";
  };
  useEffect(() => {
    if (callBackRequest) {
      dispatch(
        getDataSurvey({
          search: "",
          status: 0,
          typeSurvey: 0,
          option: {
            limit: 10,
            offset: 1,
            order: "asc",
          },
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callBackRequest]);

  const handleShowModalDelete = (value) => {
    setIsDeleteTbl(true);
    dispatch(setOpenPUDelete({ stateOpen: true, content: "", id: value.id }));
  };

  const handleShowEditModal = (value) => {
    dispatch(setOpenEditSurvey({ isOpen: true, id: value.id }));
  };

  const columns = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
      width: 70,
    },

    {
      title: <TranslateText text="Tên cuộc khảo sát" />,
      dataIndex: "name",
      key: "name",
      className: "title pointer",
      width: 600,
      ellipsis: {
        showTitle: false,
      },
      render: (value) => (
        <Tooltip placement="topLeft" title={value}>
          {value}
        </Tooltip>
      ),
    },
    {
      title: (
        <div className="statusProduct" style={{ minWidth: 100 }}>
          <p className="textStatus">
            <TranslateText text="Đối tượng" />
            <span className="iconChange">
              <IconPolygon />
            </span>
            <ul className="list" style={{ minWidth: "100px" }}>
              <li
                className="item"
                onClick={() => {
                  dispatch(setTypeSurvey(0));
                }}
              >
                Tất cả
              </li>
              <li
                className="item"
                onClick={() => {
                  dispatch(setTypeSurvey(1));
                }}
              >
                Toàn bộ KH
              </li>
              <li
                className="item"
                onClick={() => {
                  dispatch(setTypeSurvey(2));
                }}
              >
                CCS
              </li>
            </ul>
          </p>
        </div>
      ),
      dataIndex: "object",
      key: "object",
      className: "centerCell",
    },
    {
      title: (
        <div className="statusProduct">
          <p className="textStatus">
            <TranslateText text="Tình trạng" />
            <span className="iconChange">
              <IconPolygon />
            </span>
            <ul className="list" style={{ minWidth: "100px" }}>
              <li
                className="item"
                onClick={() => {
                  dispatch(setStatusSurvey(0));
                }}
              >
                Tất cả
              </li>
              <li
                className="item"
                onClick={() => {
                  dispatch(setStatusSurvey(1));
                }}
              >
                Chưa diễn ra
              </li>
              <li
                className="item"
                onClick={() => {
                  dispatch(setStatusSurvey(2));
                }}
              >
                Đang diễn ra
              </li>
              <li
                className="item"
                onClick={() => {
                  dispatch(setStatusSurvey(3));
                }}
              >
                Kết thúc
              </li>
            </ul>
          </p>
        </div>
      ),
      dataIndex: "status",
      key: "status",
      className: "centerCell",
      render: (text, record) => <span>{formatPrice(text)}</span>,
    },

    {
      title: <TranslateText text="Chức năng" />,
      key: "action",
      dataIndex: "action",
      className: "centerCell m10",
      render: (text, record) => {
        return (
          <div
            className="centerCell flex justify-center w-full "
            style={{ minWidth: "120px" }}
          >
            <span
              className="pointer iconTbl "
              //   onClick={() => dispatch(getLogProduct(record.id))}
            >
              <Tooltip title="Xem trước">
                <IconEye />
              </Tooltip>
            </span>
            <span
              className="pointer iconTbl "
              onClick={() => dispatch(getLogSurvey(record.id))}
            >
              <Tooltip title="Xem log">
                <IconLock />
              </Tooltip>
            </span>
            <span
              className="pointer iconTbl"
              onClick={() => handleShowEditModal(record)}
              style={{ marginRight: "1rem" }}
            >
              <Tooltip title="Chỉnh sửa">
                <IconEdit />
              </Tooltip>
            </span>
            {record.typeSurvey === 2 ? null : (
              <span
                className="pointer iconTbl"
                onClick={() => handleShowModalDelete(record)}
              >
                <Tooltip title="Xóa">
                  <IconXmark />
                </Tooltip>
              </span>
            )}
          </div>
        );
      },
    },
  ];
  // const tableLoading = {
  //   spinning: storeState.isLoading, // isLoading là biến boolean để xác định xem có đang loading hay không
  //   indicator: <IconSpin className="iconSpin" />,
  // };

  const handleDelete = () => {
    dispatch(deleteSurvey(dataDelete.id));
    setIsDeleteTbl(false);
    dispatch(setOpenPUDelete({ stateOpen: false, id: "", content: "" }));
  };
  return (
    <>
      {dataDelete.isOpenPUDelete && isDeleteTbl ? (
        <ModalDelete
          handleDelete={handleDelete}
          textDisable="Bạn có đồng ý xóa cuộc khảo sát này"
          title="Xóa cuộc khảo sát"
          width={680}
        />
      ) : null}
      <Row style={{ width: "100%" }}>
        <Table
          rowClassName={rowClassName}
          //   loading={tableLoading}
          className="wrapperTblSurvey"
          style={{ width: "100%", marginTop: "2.6rem" }}
          columns={columns}
          dataSource={dataSource}
          pagination={
            total > 10
              ? {
                  onChange: (value) => {
                    setPage(value);
                    dispatch(setPageProduct(value));
                  },
                  total,
                  pageSize: 10,
                  current: config.option.offset,
                  prevIcon: <IconPre />,
                  nextIcon: <IconNext />,
                  showSizeChanger: false,
                }
              : false
          }
        />
      </Row>
    </>
  );
};

export default TableSurvey;
